import { useEffect, useState } from 'react';

export const xs = 320;
export const sm = 400;
export const md = 768;
export const xm = 886;
export const lg = 1060;
export const ml = 1260;
export const xl = 1440;

export const BREAKPOINTS = {
  xs,
  sm,
  md,
  xm,
  ml,
  lg,
  xl,
};

function getBreakpointOrSize(breakpoint) {
  // Accepts breakpoint name or value. i.e. 'md' string or breakpoints.md variable
  if (typeof breakpoint === 'string') {
    return BREAKPOINTS[breakpoint];
  }
  return breakpoint;
}

export function useBreakpointRange({ from, to }, { onEnter, onLeave }) {
  const [currentState, setCurrentState] = useState('');
  const fromSize = getBreakpointOrSize(from) ?? 0;
  const toSize = getBreakpointOrSize(to);

  useEffect(() => {
    function handleResize() {
      const screenWidth = window.innerWidth;
      const withinFrom = screenWidth > fromSize;
      const withinTo = !toSize || screenWidth < toSize;
      const newState = `${withinFrom}-${withinTo}`;

      // Ensures it runs once on enter and once on leave
      if (currentState !== newState) {
        setCurrentState(newState);

        if (withinFrom && withinTo && onEnter) {
          onEnter();
        } else if (onLeave) {
          onLeave();
        }
      }
    }

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [fromSize, toSize, onEnter, onLeave, currentState, setCurrentState]);
}
